import { render, staticRenderFns } from "./RedefinirSenha.vue?vue&type=template&id=258fbe0c&scoped=true"
import script from "./RedefinirSenha.vue?vue&type=script&lang=js"
export * from "./RedefinirSenha.vue?vue&type=script&lang=js"
import style0 from "./RedefinirSenha.vue?vue&type=style&index=0&id=258fbe0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258fbe0c",
  null
  
)

export default component.exports